const {Component} = require("react");
const SubjectTags = require("components/widgets/SubjectTags");
const env = require("services/env");
const router = require("services/router");
const {classList} = require("helpers/html");
const {encodeState} = require("helpers/url");

class SearchLight extends Component {

	constructor(props) {
		super(props);
		this.state = {
			subjects: []
		};
	}

	get subjectsPool() {
		return env.get("options.subjects", []);
	}

	get searchState() {
		return {
			subjects: this.state.subjects.map(subject => subject.id)
		};
	}

	onInputChange = (subjects) => {
		this.setState({subjects});
	};

	onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		window.location = this.state.subjects.length === 0 ?
			router.route("find-teachers") :
			router.route("find-teachers", {
				state: encodeState(this.searchState)
			});
	};

	renderTags() {
		return this.subjectsPool.filter(subject => subject.featured).map(subject => {
			const href = router.route("find-teachers", {state: encodeState({subjects: [subject.id]})});

			return (
				<a key={subject.id} href={href} className="tag">{subject.name}</a>
			);
		});
	}

	render() {
		return (
			<div className={classList("search-light", "form-container", this.props.className)}>
				<div className="form-box">
					<form onSubmit={this.onSubmit}>
						<div className="input-wrap">
							<SubjectTags placeholder="Fag" pool={this.subjectsPool} value={this.state.subjects}
													 handleChange={this.onInputChange}/>
						</div>
						<input type="submit" value="Find underviser" className="btn"/>
						<input type="submit" value="" className="btn mobileSearchBtn"/>
					</form>
				</div>
				<div className="tag-wrap">
					<p>Populære:</p>
					{this.renderTags()}
				</div>
			</div>
		);
	}

}

module.exports = SearchLight;


// WEBPACK FOOTER //
// ./resources/js/components/frontend/SearchLight.js